// components/DashboardStats.js
import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Skeleton,
  useTheme,
  alpha,
} from "@mui/material";
import {
  CreditCard,
  SimCard,
  PendingActions,
  Receipt,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const StatCard = ({ title, value, icon: Icon, color, loading }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={0}
      sx={{
        position: "relative",
        overflow: "hidden",
        border: `1px solid ${theme.palette.divider}`,
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: theme.shadows[8],
        },
      }}
    >
      {/* Background decoration */}
      <Box
        sx={{
          position: "absolute",
          right: -20,
          top: -20,
          width: 120,
          height: 120,
          borderRadius: "50%",
          background: alpha(theme.palette[color].main, 0.15),
          zIndex: 0,
        }}
      />

      <CardContent sx={{ position: "relative", zIndex: 1 }}>
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              bgcolor: theme.palette[color].main,
              p: 1.5,
              borderRadius: 2,
              mr: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 4px 14px ${alpha(theme.palette[color].main, 0.4)}`,
            }}
          >
            <Icon sx={{ color: "white" }} />
          </Box>
          <Box>
            {loading ? (
              <Skeleton width={60} height={32} />
            ) : (
              <Typography variant="h5" fontWeight="bold">
                {value}
              </Typography>
            )}
            <Typography color="textSecondary" variant="body2">
              {title}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

const DashboardStats = ({ stats, loading }) => {
  const { t } = useTranslation();

  const statItems = [
    {
      title: t("dashboard.stats.totalOrders"),
      value: stats.totalOrders,
      icon: SimCard,
      color: "primary",
    },
    {
      title: t("dashboard.stats.activeESIMs"),
      value: stats.activeESIMs,
      icon: CreditCard,
      color: "success",
    },
    {
      title: t("dashboard.stats.pendingESIMs"),
      value: stats.pendingESIMs,
      icon: PendingActions,
      color: "warning",
    },
    {
      title: t("dashboard.stats.recentTransactions"),
      value: stats.recentTransactions,
      icon: Receipt,
      color: "info",
    },
  ];

  return (
    <Grid container spacing={3}>
      {statItems.map((item) => (
        <Grid item xs={12} sm={6} md={3} key={item.title}>
          <StatCard {...item} loading={loading} />
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardStats;
